<div class="media-details-form" [class.form-disabled]="isDisabled">
    <form [formGroup]="mediaForm" style="width: 100%;">

        <input #fileInput type="file"
               (change)="onFileSelected($event)"
               class="input-hidden"
               [id]="fileInputId"
               [disabled]="isDisabled"
               style="display: none;">

        <input #cameraInput type="file"
               accept="image/*,video/*"
               capture="environment"
               (change)="onFileSelected($event)"
               style="display: none;">

        <!-- No file selected and not editing: show upload controls -->
        <div class="upload-row-group" *ngIf="!selectedFile && !editMode">
            <label [for]="fileInputId"
                   class="btn-upload-trigger"
                   [class.disabled-label]="isDisabled">
                <span class="material-icons">cloud_upload</span>
                {{ "mediaDetails.noFileSelected" | translate }}
            </label>
            <button type="button"
                    class="btn-camera"
                    (click)="cameraInput.click()"
                    [disabled]="isDisabled"
                    [title]="'mediaDetails.camera' | translate">
                <span class="material-icons">photo_camera</span>
            </button>
        </div>

        <!-- File selected or editing: name input inline with re-pick buttons -->
        <div class="upload-row-group" *ngIf="selectedFile || editMode">
            <input class="form-control name-inline"
                   type="text"
                   formControlName="name"
                   [readonly]="isDisabled">
            <label [for]="fileInputId"
                   class="btn-refile"
                   [class.disabled-label]="isDisabled"
                   [title]="'mediaDetails.noFileSelected' | translate">
                <span class="material-icons">folder_open</span>
            </label>
            <button type="button"
                    class="btn-camera"
                    (click)="cameraInput.click()"
                    [disabled]="isDisabled"
                    [title]="'mediaDetails.camera' | translate">
                <span class="material-icons">photo_camera</span>
            </button>
        </div>
    </form>
</div>